import { render, staticRenderFns } from "./UserGroupManagement.vue?vue&type=template&id=abc6f778"
import script from "./UserGroupManagement.vue?vue&type=script&lang=js"
export * from "./UserGroupManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports